module.exports = __webpack_public_path__ + "LatoLatin-Italic.d9129929b06db37a97fe.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Italic.ttf
// module chunks = styles